import { Link } from 'react-router-dom';
import AviumLogo from './AviumLogo';
import { STATUS_PAGE_URL } from '../../lib/siteConfig';

/**
 * PublicFooter — shared footer for the public marketing/SEO surfaces (the
 * /learn + /for hubs and their detail pages). Its real job beyond chrome is
 * INTERNAL LINKING: it points every public page at the hubs (/learn, /for) and
 * the sales deck, so those pages stop being orphans — both for human navigation
 * and for SEO (internal links pass ranking signal and let crawlers discover the
 * full cluster from any entry point).
 */
export default function PublicFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-brand-primary-deepest text-white/60 text-sm mt-auto">
      <div className="max-w-5xl mx-auto px-6 py-10">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8">
          <div className="max-w-xs">
            <Link to="/" className="inline-flex items-center gap-2 text-white">
              <AviumLogo size={28} variant="dark" />
              <span className="font-extrabold text-lg tracking-tight">Avium</span>
            </Link>
            <p className="mt-3 text-white/45">See the work · Plan the capacity · Catch the risk</p>
          </div>

          <nav className="flex flex-wrap gap-x-12 gap-y-6">
            <div>
              <div className="text-xs font-bold uppercase tracking-wider text-brand-accent mb-2">Learn</div>
              <ul className="space-y-1.5">
                <li><Link to="/demo" className="hover:text-white transition-colors">Watch the demo</Link></li>
                <li><Link to="/learn" className="hover:text-white transition-colors">All Signals</Link></li>
                <li><Link to="/for" className="hover:text-white transition-colors">For your role</Link></li>
                <li><Link to="/blog" className="hover:text-white transition-colors">Blog</Link></li>
              </ul>
            </div>
            <div>
              <div className="text-xs font-bold uppercase tracking-wider text-brand-accent mb-2">Company</div>
              <ul className="space-y-1.5">
                <li><a href="/sales-brochure.html" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Why Avium ↗</a></li>
                <li><Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link></li>
                <li><a href={STATUS_PAGE_URL} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">System status ↗</a></li>
              </ul>
            </div>
            <div>
              <div className="text-xs font-bold uppercase tracking-wider text-brand-accent mb-2">Get started</div>
              <ul className="space-y-1.5">
                <li><Link to="/login" className="hover:text-white transition-colors">Sign in</Link></li>
                <li><Link to="/login" className="hover:text-white transition-colors">Create an organization</Link></li>
              </ul>
            </div>
          </nav>
        </div>

        <div className="mt-8 pt-6 border-t border-white/10 text-xs text-white/40">
          © {year} Avium · AI delivery intelligence
        </div>
      </div>
    </footer>
  );
}
